import { SimpleModalId } from 'constants/modalId';
import { ArchiveEventModalContentContainer } from './ArchiveEventModalContentContainer';
import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';

export const ArchiveEventModal = makeGuardedModal(SimpleModalId.ArchiveEvent, ArchiveEventModalContentContainer);
